<template>
    <v-card flat>
        <v-card-title>
            <h4>Формирование приложения к акту ЛПО</h4>
        </v-card-title>
        <v-card-text>
            <v-form class="px3">
                <input type="file" ref="fileInput" @change="onChangeFile">
                <v-select
                    v-model="selected.workers"
                    :items="available.workers"
                    label="Исполнитель"
                    outlined
                    multiple
                    hide-details
                    class="mb-2"
                ></v-select>
                <v-btn :disabled="selected.disabled || selected.fileSelected == null || selected.workers.length == 0" @click="getPril()">Сформировать</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
  name: 'dnreport',
  data () {
    return {
      selected: {
          workers:[],
          fileSelected: null,
          disabled: false
      },
      available: {
          workers: ["Астапенко С.А.","Баранов К.А.","Баранова Н.В.","Безруких М.Н.","Вагнорюс Е.А.","Вагнорюс П.А.","Валайнис С.И.",
            "Вединистов Р.В.","Вединистова К.С.","Войтов А.Н.","Демидович А.А.","Дьяченко В.А.","Зарубицкий А.И.","Звягинцев С.А.",
            "Инюшкин С.В.","Ковалёв М.А.","Лазарев А.В.","Лесников Е.М.","Линдт Е.А.","Мамонтов С.Я.","Моисеев И.В.","Остропицкая Е.М.",
            "Охримов А.М.","Разнобарский В.Г.","Редькин А.Ю.","Сафронова И.Е.","Сахарков Ю.А.","Сахаров А.А.","Сахарова Е.О.",
            "Семин В.С.","Семина А.Л.","Степанова М.А.","Усольцев К.О.","Чернышева А.В.","Шайдуров Р.Л.","Шестаков Д.В."]
        }
    }
  },
  mounted: function () {

  },
  computed: {
    
  },
  components: {
  },
  methods: {
      b64toBlob(b64Data, contentType='', sliceSize=512) {
        const byteCharacters = atob(b64Data)
        const byteArrays = []
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize)
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            byteArrays.push(byteArray)
        }
        const blob = new Blob(byteArrays, {type: contentType})
        return blob
      },
      onChangeFile() {
          this.selected.fileSelected = this.$refs.fileInput.files[0];
      },
      getPril() {
          if(this.selected.workers.length > 0 && this.selected.fileSelected != null) {
              let data = new FormData()
              data.append('workers', this.selected.workers)
              data.append('file1', this.selected.fileSelected)
              this.selected.disabled = true
              this.$http.post('./api/pril3', data, {emulateJSON: true}).then(function(responce) {
                  this.selected.disabled = false
                  if(responce.body.status) {
                    const blob = this.b64toBlob(responce.body.doc, "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    var fileName = 'приложение 3.docx'
                    link.download = fileName  
                    link.click()
                  } else {
                      alert(responce.body.error)
                  }
              }, function(error) {
                    alert(error)
              })
          }
      }
  }
}
</script>
